<template>
  <div class="flex flex-col overflow-hidden">
    <Header :brandInfo="brandInfo" class="min-h-[75px]"/>
    <main class="grow">
    <Steps :currentStepProp="currentStep" @update-current-step="updateCurrentStep"></Steps>

    <div v-if="currentStep == 1">
      <DocumentSection :jurisdictionProp="jurisdictionProp" :documentNumberProp="companyDocument" @select-document-number="getDocumentInfo"></DocumentSection>
    </div>
      <div v-if="currentStep == 2">
        <ProductSelection :jurisdictionProp="jurisdiction"
                          :documentProp="documentProp"
                          :productProp="product"
                          :companyNameProp="companyName"
                          @update-products="updateProducts"></ProductSelection>
      </div>
    <div v-if="currentStep == 3" class="bg-gray-50">
      <OrderSection :brandInfoProp="brandInfo"
                    :jurisdictionProp="jurisdiction?.uuid"
                    :documentProp="documentProp"
                    :companyNameProp="companyName"
                    :selectedItemsProp="selectedItems"
                    :availableItemsProp="availableItems"></OrderSection>
    </div>
  </main>
    <Footer :brandInfo="brandInfo"/>
  </div>
</template>
<script setup>

import Header from '../../partials/Header.vue'
import OrderSection from "../../partials/OrderSection.vue";
import DocumentSection from "../../partials/DocumentSection.vue";


import Footer from '../../partials/Footer.vue'
import {onMounted, reactive, ref } from "vue";
import {usePage} from "@inertiajs/inertia-vue3";
import Steps from '@/Components/Steps.vue';
import SelectJurisdiction from "../../partials/SelectJurisdiction.vue";
import ProductSelection from "../../partials/ProductSelection.vue";


const props = defineProps({
  documentProp: {
    type: Object,
    required: false,
    default: null
  },
  productProp: {
    type: Object,
    required: false,
    default: null
  },
  loading: {
    type: Boolean,
    required: false,
    default: false
  },
  brandInfo: {
    type: Object,
    required: true,
    default: null
  },
  jurisdictionProp: {
    type: Object,
    required: false,
    default: null
  },
})
const currentStep = ref(usePage().props.value.documentProp? 2 : 1);

const companyDocument = ref(usePage().props.value.documentProp);

const product = ref(usePage().props.value.productProp);
const companyName = ref(null);
const jurisdiction = ref(null);

const availableItems = ref(null);
const selectedItems = ref(null);

const updateCurrentStep = (step) => {
  currentStep.value =   step;
}

const getDocumentInfo = (documentInfo) => {
  currentStep.value =   2;
  companyDocument.value =   documentInfo;
  jurisdiction.value = documentInfo.jurisdiction;

}

const updateProducts = (products) => {
  currentStep.value = 3;
  availableItems.value = products.availableItems;
  selectedItems.value = products.selectedItems;

}


onMounted(() => {

});

</script>

